import { Navigate, useLocation } from 'react-router-dom';
import { resolveLegacyExperiencePath } from './routes';

export default function ExperiencePage() {
  const location = useLocation();
  const target = resolveLegacyExperiencePath(location.search);

  return <Navigate to={target} replace />;
}
